export default __webpack_public_path__ + "static/media/FoodChainForest_06.13415b1c.png";